import { IYearMonth } from './types';

export const fromYearMonthString = (value?: string | null): IYearMonth | null => {
  if (!value) {
    return null;
  }
  const match = /^(\d{4})-(\d{2})$/.exec(value);
  if (!match) {
    return null;
  }
  const year = Number(match[1]);
  const month = Number(match[2]); // 1-12
  if (!Number.isFinite(year) || !Number.isFinite(month) || month < 1 || month > 12) {
    return null;
  }
  return { year, monthIndex: month - 1 };
};

export const toYearMonthString = (year: number, monthIndex: number): string => {
  const month = String(monthIndex + 1).padStart(2, '0');
  return `${year}-${month}`;
};

export const toMonthStartDate = (ym: IYearMonth): Date => new Date(ym.year, ym.monthIndex, 1);

export const toMonthEndDate = (ym: IYearMonth): Date => new Date(ym.year, ym.monthIndex + 1, 0);

